// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { Preferences } from '@capacitor/preferences'
import { isNonEmptyString } from '@utils/type-checkers'
import { createResponseObj, generateHeaders } from '..'
import { stripeBaseUrl } from '.'


type GetPaymentMethodsResponse = (SuccessResponse & {
    paymentMethods: CreditCard[]
}) | FailedResponse

export class GetPaymentMethodsRequest extends Request {
    private constructor(userId: string, init?: RequestInit) { super(`${stripeBaseUrl}/user/${userId}/payment-methods`, init) }
    static async init(userId: string | undefined, init?: RequestInit) {
        if (!isNonEmptyString(userId)) throw createResponseObj<FailedResponse>({ status: 'failed', type: 'local', name: 'invalid-user-id ', message: 'Invalid User Id' })
        
        let isBeta = false
        try {
            const { value: betaValue } = await Preferences.get({ key: 'beta' })
            isBeta = betaValue === 'true'
        } catch {
            isBeta = false
        }

        // The generateHeaders method sets the Content-Type header to `application/json` by default.
        // That header isn't supported with GET requests and has to be removed.
        const headers = await generateHeaders("Clerk-Token", init?.headers)
        headers.set('beta-channel', String(isBeta))
        headers.delete('Content-Type')
        return new GetPaymentMethodsRequest(userId, {
            ...init,
            method: 'GET',
            headers: headers,
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<CreditCard[]> {
        const response = await fetch(this)
        const data = createResponseObj<GetPaymentMethodsResponse>(await response.json())
        console.info("Get Payment Methods Results:", data)
    
        switch (data.status) {
            case 'successful': return data.paymentMethods
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}